import Utils from "../../utils/Utils";
import Alert from "../../utils/messages";

export default {

    init() {

        function parseResponseError(error) {

            if (error.response) {

                const status = error.response.status;

                if (status === 422) {
                    return Alert.buildMessageList(Alert.parseValidationExceptionResponse(error.response));
                } else {
                    return Alert.buildMessageList("Non è stato possibile eseguire l'aggiornamento");
                }
            } else {
                return Alert.buildMessageList("Non è stato possibile eseguire l'aggiornamento");
            }
        }

        const CARD_PAYMENTS = "#card-payments";

        const TABLE_PAYMENTS_BODY = "#table-payments > tbody";

        const BTN_CREATE = "#btn-create";
        const BTN_EDIT = ".btn-edit";
        const BTN_DESTROY = ".btn-destroy";
        const BTN_MARK_AS_PAID = ".btn-mark-as-paid";

        const DATA_PAYMENT_ID = "payment-id";

        const DATA_INDEX_ROUTE = "index-route";
        const DATA_STORE_ROUTE = "store-route";
        const DATA_UPDATE_ROUTE = "update-route";
        const DATA_DELETE_ROUTE = "delete-route";

        //MODAL CREATE EDIT PAYMENT
        const MODAL_CREATE_EDIT_PAYMENT = "#modal-create-edit-payment";
        const INPUT_MODE = "#mcep-input-mode";
        const INPUT_EXPIRATION = "#mcep-input-expiration";
        const INPUT_AMOUNT = "#mcep-input-amount";
        const INPUT_DESCRIPTION = "#mcep-input-description";
        const INPUT_PAID = ".mcep-input-paid";

        const ROW_ERRORS = "#modal-create-edit-payment #row-errors";
        const LIST_ERRORS = "#modal-create-edit-payment #list-errors";

        const BTN_SUBMIT = "#mcep-btn-submit";

        const TH_PAYMENTS_TOTAL = "#th-payments-total";

        const TABLE_PAYMENT_ROW_TEMPLATE = ({payment}) => `
            <tr>
                <td>
                    <button
                       class="btn btn-sm btn-primary waves-effect waves-light btn-edit"
                       title="Modifica" data-payment-id="${payment.id}">
                        <i class="bx bxs-edit font-size-16 align-middle"></i>
                    </button>
                    <button
                       class="btn btn-sm btn-danger waves-effect waves-light btn-destroy"
                       title="Elimina" data-payment-id="${payment.id}">
                        <i class="bx bxs-trash font-size-16 align-middle"></i>
                    </button>
                    <button
                        class="btn btn-sm btn-success waves-effect waves-light btn-mark-as-paid ${payment.paid ? 'd-none' : ''}"
                        title="paga"
                        data-payment-id="${payment.id}">
                        <i class="bx bxl-product-hunt font-size-16 align-middle"></i>
                    </button>
                </td>
                <td class="text-center">${payment.paid ? "<i class='font-size-18 bx bx-check'></i>" : ''}</td>
                <td>${payment.friendly_mode}</td>
                <td>${moment(payment.expiration).format('DD/MM/YYYY')}</td>
                <td>${numeral(parseFloat(payment.amount)).format('0,0.00')}</td>
                <td>${Utils.escapeHtml(payment.description)}</td>
            </tr>
        `;

        let _index_route = "";
        let _store_route = "";
        let _update_route = "";
        let _delete_route = "";

        let _payments = [];

        function findPaymentById(payment_id) {
            return _payments.find(payment => parseInt(payment.id) === parseInt(payment_id));
        }

        function getIndexRoute() {
            return $(CARD_PAYMENTS).data(DATA_INDEX_ROUTE);
        }

        function getStoreRoute() {
            return $(CARD_PAYMENTS).data(DATA_STORE_ROUTE);
        }

        function getUpdateRoute() {
            return $(CARD_PAYMENTS).data(DATA_UPDATE_ROUTE);
        }

        function getDeleteRoute() {
            return $(CARD_PAYMENTS).data(DATA_DELETE_ROUTE);
        }

        function getFormData() {

            return {
                mode: $(INPUT_MODE).val(),
                expiration: $(INPUT_EXPIRATION).val(),
                amount: $(INPUT_AMOUNT).val(),
                description: $(INPUT_DESCRIPTION).val(),
                paid: $(`${INPUT_PAID}:checked`).val(),
            }
        }

        function clearFormData() {

            $(INPUT_MODE).val($(`${INPUT_MODE} option:first`).val()).change();
            $(INPUT_EXPIRATION).val("");
            $(INPUT_AMOUNT).val("");
            $(INPUT_DESCRIPTION).val("");
            $(`${INPUT_PAID}`).prop('checked', false).change();
            $(`${INPUT_PAID}[value="0"]`).prop('checked', true).change();
            $(BTN_SUBMIT).data(DATA_PAYMENT_ID, "");
            $(LIST_ERRORS).html("");
            $(ROW_ERRORS).hide();
        }

        function fillFormData(payment) {
            clearFormData();
            $(INPUT_MODE).val(payment.mode).change();
            $(INPUT_EXPIRATION).val(payment.expiration);
            $(INPUT_AMOUNT).val(payment.amount);
            $(INPUT_DESCRIPTION).val(payment.description ?? "");
            $(`${INPUT_PAID}`).prop('checked', false).change();
            $(`${INPUT_PAID}[value=${payment.paid ? "1" : "0"}]`).prop('checked', true).change();
            $(BTN_SUBMIT).data(DATA_PAYMENT_ID, payment.id);
        }

        function closeCreateEditModal() {
            clearFormData();
            $(MODAL_CREATE_EDIT_PAYMENT).modal('hide');
        }

        function paymentsLoaded(payments) {

            _payments = payments;

            const data = [];

            let total = 0;

            for (const payment of _payments) {
                data.push({
                    payment: payment,
                });
                total = total + parseFloat(payment.amount);
            }

            console.log(total);

            $(TH_PAYMENTS_TOTAL).text(numeral(total).format('0,0.00'));

            const html = data.map(TABLE_PAYMENT_ROW_TEMPLATE).join('');
            $(TABLE_PAYMENTS_BODY).html(html);
        }

        function getPayments() {

            httpRequest.get(getIndexRoute())
                .then(response => paymentsLoaded(response.data.data))
                .catch(error => {
                });
        }

        function storePayment(data) {

            httpRequest.post(getStoreRoute(), data)
                .then(response => {
                    getPayments();
                    closeCreateEditModal();
                })
                .catch(error => {
                    $(LIST_ERRORS).html(parseResponseError(error));
                    $(ROW_ERRORS).show();
                });
        }

        function updatePayment(payment_id, data) {

            data['payment_id'] = payment_id;
            httpRequest.put(getUpdateRoute(), data)
                .then(response => {
                    getPayments();
                    closeCreateEditModal();
                })
                .catch(error => {
                    $(LIST_ERRORS).html(parseResponseError(error));
                    $(ROW_ERRORS).show();
                });
        }

        function deletePayment(payment_id, data = {}) {
            data['payment_id'] = payment_id;
            httpRequest.delete(getDeleteRoute(), {data: data})
                .then(response => getPayments())
                .catch(error => {
                });
        }

        function paymentMarkedAsPaid(payment, callback) {

            const index = _payments.findIndex(p => parseInt(p.id) === parseInt(payment.id));

            if (index > -1) {
                _payments[index] = payment;
                paymentsLoaded(_payments);
            }

            if (callback && typeof callback === "function") {
                callback();
            }
        }

        function markPaymentAsPaid(payment_id, callback) {

            httpRequest.put(`admin/content/api/payments/${payment_id}/mark-as-paid`)
                .then(response => paymentMarkedAsPaid(response.data.data, callback))
                .catch(error => {

                });
        }

        $(BTN_CREATE).click(function (e) {
            e.preventDefault();
            clearFormData();
            $(MODAL_CREATE_EDIT_PAYMENT).modal('show');
        });

        $(BTN_SUBMIT).click(function (e) {
            e.preventDefault();

            const payment_id = $(this).data(DATA_PAYMENT_ID);

            if (Utils.isEmpty(payment_id)) {
                storePayment(getFormData());
            } else {
                updatePayment(payment_id, getFormData());
            }
        });

        $(TABLE_PAYMENTS_BODY).on('click', BTN_EDIT, function (e) {
            e.preventDefault();

            const payment_id = $(this).data(DATA_PAYMENT_ID);

            let payment = null;

            if (!Utils.isEmpty(payment_id) && (payment = findPaymentById(payment_id)) !== null) {
                fillFormData(payment);
                $(MODAL_CREATE_EDIT_PAYMENT).modal('show');
            }
        });

        $(TABLE_PAYMENTS_BODY).on('click', BTN_DESTROY, function (e) {
            e.preventDefault();

            const payment_id = $(this).data(DATA_PAYMENT_ID);

            let payment = null;

            if (!Utils.isEmpty(payment_id) && (payment = findPaymentById(payment_id)) !== null) {
                if (confirm("Vuoi veramente eliminare il pagamento selezionato?")) {
                    deletePayment(payment_id);
                }
            }
        });

        $(TABLE_PAYMENTS_BODY).on('click', BTN_MARK_AS_PAID, function (e) {
            e.preventDefault();

            const payment_id = $(this).data(DATA_PAYMENT_ID);

            let payment = null;

            if (!Utils.isEmpty(payment_id) && (payment = findPaymentById(payment_id)) !== null) {
                markPaymentAsPaid(payment_id);
            }
        });

        getPayments();
    },

    finalize() {

    }
}
